import { render, staticRenderFns } from "./OfferOrPlanItem.vue?vue&type=template&id=6df6855a&scoped=true&"
import script from "./OfferOrPlanItem.vue?vue&type=script&lang=js&"
export * from "./OfferOrPlanItem.vue?vue&type=script&lang=js&"
import style0 from "./OfferOrPlanItem.vue?vue&type=style&index=0&id=6df6855a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df6855a",
  null
  
)

export default component.exports